import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import './Auth.css';

export default function Register() {
  const [form, setForm] = useState({
    fullName: '', email: '', password: '', phone: '', country: '', role: 'patient',
  });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await apiClient.post('/auth/register', form);
      navigate('/verify-email', { state: { userId: res.data.userId, email: form.email } });
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>Create your account</h1>
        <p className="auth-subtitle">Book appointments and manage your care from anywhere.</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="fullName">Full name</label>
            <input id="fullName" required value={form.fullName} onChange={(e) => update('fullName', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" required value={form.email} onChange={(e) => update('email', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" required minLength={8} value={form.password} onChange={(e) => update('password', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="phone">Phone (optional)</label>
            <input id="phone" value={form.phone} onChange={(e) => update('phone', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="country">Country</label>
            <input id="country" required value={form.country} onChange={(e) => update('country', e.target.value)} placeholder="e.g. Kenya, United Kingdom" />
          </div>
          <div className="form-field">
            <label htmlFor="role">I am registering as</label>
            <select id="role" value={form.role} onChange={(e) => update('role', e.target.value)}>
              <option value="patient">A client seeking care</option>
              <option value="referral_partner">A referral partner (hospital, NGO, employer, school)</option>
            </select>
          </div>
          <button className="btn btn-primary" disabled={busy}>{busy ? 'Creating account…' : 'Create account'}</button>
        </form>

        <p className="auth-footer-link">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
